<template>
  <div class="style-wrapper style-wrapper-1">
    <div class="btn-pagination btn-prev" @click="swiperPrev">
      <i class="fa fa-angle-double-left"></i>
    </div>
    <div :class="['listBoxWrapper','list_box','list-box-'+listArr.module_style]">
      <swiper
        ref="mySwiper"
        v-if="swiperIsRender"
        class="my-swiper-box"
        :key="swiperKey"
        :options="swiperOption"
      >
        <swiper-slide v-for="(item,i) in imgs" :key="i">
          <one_picture
            :item="item"
            :i="i"
            :key="i"
            :pc_infor="pc_infor"
            :infor="infor"
            :imgs="imgs"
            :module="module"
          ></one_picture>
        </swiper-slide>
      </swiper>
    </div>
    <div class="btn-pagination btn-next" @click="swiperNext">
      <i class="fa fa-angle-double-right"></i>
    </div>
  </div>
</template>

<script>
import i18n from '../../../language/index'

import one_picture from "./one_picture";

export default {
  name: "basic_picture_text_swiper_group_style_1.vue",
  components: {
    one_picture,
  },
  props: {
    module: {
      type: Object,
      default: null
    },
    pc_infor: {
      type: Object,
      default: null
    },
    infor: {
      type: Object,
      default: null
    },
    type: {
      type: String,
      default: "ordinary"
    },
    imgs: {
      type: Array,
      default: function () {
        return [];
      }
    }
  },
  data() {
    return {
      swiperIsRender: true,
      swiperKey: Math.random().toString(36).substr(2),
    }
  },
  computed: {
    mb_widgets_infor() {
      return this.module.data.mb_widgets_infor;
    },
    listArr() {
      return this.module.data.listArr
    },
    swiperOption() {
      if (this.$store.state.app.view_pattern === 'pc') {
        return this.pcSwiperOption
      } else {
        return this.mobileSwiperOption
      }
    },
    pcSwiperOption() {
      const infor = this.infor;
      const pc_infor = this.pc_infor;      
      const num = parseInt(infor.col_num[infor.col_num.radio_val].value);
      const slidesPerGroup = num  // 翻页个数     // parseInt(infor.slides_group[infor.slides_group.radio_val].value);
      const loop = infor.swiper_loop === 'true' ? true : false
      const obj = {
        myVm: this,
        loop: slidesPerGroup == 1 ? loop : false,
        direction: "horizontal",
        slidesPerView: num,
        slidesPerGroup,//每次翻页个数
        observer: true,
        observeParents: true,
      }      
      const autoplay = this.templet.autoplay_obj(
        pc_infor.banner_set,
        obj
      );      
      obj.autoplay = autoplay;
      return obj;
    },
    mobileSwiperOption() {
      const num = parseInt(this.infor.col_num[this.infor.col_num.radio_val].value);
      return {
        loop: false,
        direction: 'horizontal',
        slidesPerView: num + 0.5,
        slidesPerColumn: 1,
        freeMode: true
      }
    }
  },
  watch: {
    'infor.col_num': {
      handler() {
        this.reRenderSwiper()
      },
      deep: true
    },
    'infor.banner_set': {
      handler() {
        this.reRenderSwiper()
      },
      deep: true
    },
    '$store.state.app.view_pattern'() {
      setTimeout(() => {
        this.reRenderSwiper()
      }, 500)
    }
  },
  methods: {
    swiperStart() {
      this.$refs.mySwiper.swiper.autoplay.start();
    },
    swiperStop() {      
      this.$refs.mySwiper.swiper.autoplay.stop();
    },
    swiperPrev() {
      this.$refs.mySwiper.swiper.slidePrev();
    },
    swiperNext() {
      this.$refs.mySwiper.swiper.slideNext();
    },
    reRenderSwiper() {
      this.swiperKey = Math.random().toString(36).substr(2);
    }
  }
}
</script>

<style scoped lang="scss">
.basic_picture_text_swiper {
  .list_frame {
    width: 100%;

    .listBoxWrapper {
      width: calc(100% - 80px);
    }

    .my-swiper-box {
      width: 100%;
      height: auto;
      display: flex;
      flex-flow: wrap;
      font-size: 0;
      position: relative;
    }
  }

  .style-wrapper {
    display: flex;
    align-items: center;
  }

  .btn-pagination {
    width: 40px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    cursor: pointer;
    border-radius: 40px;
    position: relative;
    background: rgba(0, 0, 0, 0.2);

    &:before {
      content: "";
      position: absolute;
      display: block;
      width: 10px;
      height: 18px;
      background: url(/static/image/backimg1.png) -23px -268px;
      top: 50%;
      left: 50%;
      transform: translate(-50%) translateY(-50%);
    }

    &.btn-next:before {
      background-position-x: -53px;
      left: 54%;
    }

  }

  .btn-pagination i {
    font-size: 35px;
    color: #000;
    vertical-align: middle;
    display: none;
  }


  .swiper-slide {
    padding: calc(0.3% + 8px);
  }

}
</style>
<style lang="scss">
.basic_picture_text_swiper {
  .swiper-wrapper {
    height: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/widgets/basic_picture_text_swiper/components/group_style_1.vue